// extracted by mini-css-extract-plugin
export var standaloneTable = "_fx-0";
export var standaloneTableWithBodyFill = "_fx-1";
export var withExtraHeader = "_fx-2";